import { View } from '../base/View';
import { ensureElement, formatNumber } from '../../utils/utils';
export class BasketView extends View {
    constructor(container, events, emptyState) {
        super(container);
        this.events = events;
        this._trigger = document.querySelector('.header__basket');
        this._count = document.querySelector('.header__basket-counter');
        this._title = ensureElement('.modal__title', container);
        this._list = ensureElement('.basket__list', container);
        this._actions = ensureElement('.modal__actions', container);
        this._submit = ensureElement('.basket__button', container);
        this._price = ensureElement('.basket__price', container);
        this.emptyState = emptyState;
        this._trigger.addEventListener('click', () => {
            this.events.emit('basket:open');
        });
        this._submit.addEventListener('click', () => {
            this.events.emit('order:open-step-details');
        });
        this.items = [];
    }
    set count(value) {
        this.setText(this._count, value);
    }
    set total(value) {
        const totalValue = `${formatNumber(value)} синапсов`;
        this.setText(this._price, totalValue);
    }
    set items(value) {
        if (value === null || value === void 0 ? void 0 : value.length) {
            this.toggleEmptyState(false);
            this._list.replaceChildren(...value);
        }
        else {
            this.toggleEmptyState(true);
        }
    }
    toggleEmptyState(state) {
        if (state) {
            this.setHidden(this._title);
            this.setHidden(this._actions);
            this._list.replaceChildren(this.emptyState);
        }
        else {
            this.setVisible(this._title);
            this.setVisible(this._actions);
        }
    }
}
